import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const LOGO_URL = "/media/logo-metallic-transparent-clean.png";

export default function BrandLogo({ size = 240, to = null, testid = "brand-logo" }) {
  const inner = (
    <motion.div
      data-testid={testid}
      initial={{ opacity: 0, scale: 0.96 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
      style={{ width: size, height: size }}
      className={`relative select-none ${to ? "cursor-pointer" : "pointer-events-none"}`}
      aria-label="THE BLACK HOUSE"
    >
      <img
        src={LOGO_URL}
        alt="THE BLACK HOUSE"
        width={size}
        height={size}
        loading="eager"
        decoding="async"
        fetchPriority="high"
        draggable={false}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          imageRendering: "-webkit-optimize-contrast",
          transform: "translateZ(0)",
        }}
      />
    </motion.div>
  );

  if (to) {
    return (
      <Link to={to} aria-label="Return to homepage" data-testid={`${testid}-link`}>
        {inner}
      </Link>
    );
  }
  return inner;
}
